import { mainAxios } from '@/plugins/axios';

class orderService {
  async list(query) {
    const response = await mainAxios.get(query);
    return response.data;
  }
  async create(data) {
    const response = await mainAxios.post('/ordem-compra', data);
    return response.data;
  }
  async update(id, data) {
    const response = await mainAxios.put('/ordem-compra/' + id, data);
    return response.data;
  }
  async view(id) {
    const response = await mainAxios.get('/ordem-compra/' + id);
    return response.data;
  }
  async viewOrderCompany(id, codEmp, attach = '') {
    const response = await mainAxios.get(`/orders/empresa/${codEmp}/ordem-compra/${id}?attach=${attach}`);
    return response.data;
  }
  async listProducts(query) {
    const response = await mainAxios.get(query);
    return response.data;
  }
  async delete(id) {
    const response = await mainAxios.delete('/ordem-compra/' + id);
    return response.data;
  }
  async download() {
    const response = await mainAxios.get('/ordem-compra/download');
    return response.data;
  }
  async receipt(payload) {
    const response = await mainAxios.post('/recebimento-mercadorias', payload);
    return response.data;
  }
  async receiptOrder(orderId, payload) {
    const response = await mainAxios.put('/recebimento-mercadorias/' + orderId, payload);
    return response.data;
  }
  async historico(search, cod_emp = '', cod_forn = '') {
    const response = await mainAxios.get('/historico-compra/produtos?search=' + search + '&cod_emp=' + cod_emp + '&cod_forn=' + cod_forn);
    return response.data;
  }
    async canceled(id) {
    const response = await mainAxios.put(`/ordem-compra/${id}/cancelar`);
    return response.data;
  }
}

export default new orderService();
